import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from '../../modal'
import Button from '../../button'
import { useMutation } from '@apollo/react-hooks'
import SendSignatureRequestReminderMutation from '../../../queries/SendSignatureRequestReminder'
import LoadingButton from '../../loading-button'
import { useSnackbar } from '../../../contexts/SnackbarContext'
import { sendReminder } from '../../../helpers/DocuSignUtil'
import { EsignVendors } from '../../constants'

const ContentWrapperElement = styled.div`
  width: 35rem;
`

const ButtonsContainerElement = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
`

const TextElement = styled.h4`
  font-size: 1rem !important;
  font-weight: 200 !important;
  margin-top: 1.2rem !important;
  margin-bottom: 0.8rem !important;
`

function SendReminderModal({
  documentId,
  onClose,
  esignVendor,
  docusignServiceBaseUrl,
  documentKey,
}) {
  const { setSuccessMessage, setErrorMessage } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const onCompleted = () => {
    setSuccessMessage('Reminder sent')
    onClose()
  }

  const onError = () => {
    setErrorMessage('There was an error sending the reminder')
    onClose()
  }

  const [sendSignatureRequestReminderMutation] = useMutation(
    SendSignatureRequestReminderMutation,
    {
      variables: {
        documentId,
      },
      onCompleted,
      onError,
    },
  )

  const handleClose = () => !loading && onClose()
  const handleSubmit = (...args) => {
    setLoading(true)

    if (esignVendor === EsignVendors.DocuSign) {
      sendReminder(docusignServiceBaseUrl, documentKey, onCompleted, onError)
    } else {
      sendSignatureRequestReminderMutation(...args)
    }
  }

  return (
    <Modal title="Send eSign reminder" onClose={handleClose}>
      <ContentWrapperElement>
        <TextElement>Are you sure you want to send the reminder?</TextElement>
        <ButtonsContainerElement>
          <Button color="gray" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            disabled={loading}
            isLoading={loading}
            onClick={handleSubmit}
            width="6rem"
          >
            Yes, send
          </LoadingButton>
        </ButtonsContainerElement>
      </ContentWrapperElement>
    </Modal>
  )
}

export default SendReminderModal
